// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import iview from 'iview'
import 'iview/dist/styles/iview.css';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import axios from 'axios';
import { localData, sessionData } from "../src/utils/local";

import router from './router'

Vue.prototype.localData = localData;
Vue.prototype.sessionData = sessionData;

Vue.config.productionTip = false;

//图片预览插件
Vue.use(iview);
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { 'inline': false, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
// Vue.use(axios);
Vue.prototype.$ajax = axios
// 将时间戳转日期格式的过滤器
Vue.filter('dateFormat', (dataStr, format) => {
  let time = new Date(dataStr);
  function timeAdd(str) {
    if (str < 10) {
      str = '0' + str;
    }
    return str
  }
  let y = time.getFullYear();
  let m = time.getMonth() + 1;
  let d = time.getDate();
  let h = time.getHours();
  let mm = time.getMinutes();
  let s = time.getSeconds();
  if(format) {
    return format.replace('yyyy', y).replace('MM', m).replace('dd', d).replace('hh', h).replace('mm', mm).replace('ss', s);
  }
  return y + '-' + timeAdd(m) + '-' + timeAdd(d) + ' ' + timeAdd(h) + ':' + timeAdd(mm) + ':' + timeAdd(s);
});

// 金额转大写
Vue.filter('digitUppercase', (v) => {
  return digitUppercase(v);
});
Vue.prototype.$digitUppercase = digitUppercase;
function digitUppercase(price) {
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ]
  let num = Math.abs(price)
  let s = ''
  fraction.forEach((item, index) => {
    s += (digit[Math.floor(num * 10 * (10 ** index)) % 10] + item).replace(/零./, '')
  })
  s = s || '整'
  num = Math.floor(num)
  for (let i = 0; i < unit[0].length && num > 0; i += 1) {
    let p = ''
    for (let j = 0; j < unit[1].length && num > 0; j += 1) {
      p = digit[num % 10] + unit[1][j] + p
      num = Math.floor(num / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }

  return s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}



// 文件路径转换
Vue.prototype.$formatFileUrl = function(url) {
  let type = 'Files';
  let isFile = (/^Supervision\/(Sign|FaceRecognition)\/.+$/).test(url);
  if(typeof url != 'string') return '';
  if(/^http[s]?:\/\/.+$/.test(url)) return url;
  if(!isFile && ['.jpg', '.jpeg', '.png', '.gif'].includes(url.substring(url.lastIndexOf('.')))) type = 'Images';
  return `${process.env.baseURL}/${type}/${url}`;
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js